module.exports = __webpack_public_path__ + "static/media/menu-directory.0dfec52c.svg";